import { defineWidgetCore } from "../../widgetDefinition";
import { resolveTemplate } from "../../Utils/resolveTemplate";
import type { ChartComponentSpec, WidgetResponseSpec } from "../../Processing/types";
import { adaptResponse } from "../../Processing/adapt";
import { buildRawConfig } from "../../Processing/buildRaw";
import { applyMutations } from "../../Processing/mutations";
import { applySort } from "../../Processing/sort";
import { renderChart } from "../../PDF/renderers/chartPdfRenderer";

const EMPTY_RESPONSE: WidgetResponseSpec = { widget_id: "", series: [] };

export const chartCore = defineWidgetCore<ChartComponentSpec>({
  process(spec, response) {
    const s = spec;
    const skipDefaultSort =
      s.chart_builder_misc?.groupBy === "drill" || s.widgetMutations?.sortConfig?.enabled === true;
    const adapted = adaptResponse(response ?? EMPTY_RESPONSE, skipDefaultSort);
    const sorted = applySort(adapted, s);
    const raw = buildRawConfig(s, sorted);
    const final = applyMutations(raw, s);
    return { type: "chart", spec: s, chart: { chartOptions: final } };
  },
  pdf: {
    capture: "highcharts",
    buildSnapshot({ processed, slicerValues }) {
      if (processed.type !== "chart") return null;
      const rawTitle = processed.spec.display.title;
      const title = rawTitle == null ? null : resolveTemplate(rawTitle, slicerValues).resolved;
      return { type: "chart", title, summary: null };
    },
    render({ id, snapshot, rect, scale, chartImages }) {
      if (snapshot.type !== "chart") return null;
      return renderChart(snapshot, rect, scale, chartImages[id]);
    },
  },
});
